import config from '@/assets/config'
import { getFrames } from '@/utils'

const ww = window.innerWidth
const wh = window.innerHeight

// 场景基础数据
const s2ScrollD = config.scenesScrollD[1] - config.scenesScrollT[1] * 0.53
const s2ScrollT = config.scenesScrollT[1]
// 场景
const s2StaticW = wh * 2784 / 2436
const s2StaticD = s2ScrollD + 0 * s2ScrollT
const s2StaticT = 1 * s2ScrollT
const s2StaticV = s2StaticW / s2StaticT
// 云1
const s2Cloud1L = 700 / 2784
const s2Cloud1ScrollW = s2StaticW * (1 - s2Cloud1L)
const s2Cloud1D = s2StaticD + s2Cloud1L * s2StaticT
const s2Cloud1T = s2Cloud1ScrollW / s2StaticV
// 云2
const s2Cloud2L = 2500 / 2784
const s2Cloud2ScrollW = s2StaticW * (1 - s2Cloud2L)
const s2Cloud2D = s2StaticD + s2Cloud2L * s2StaticT
const s2Cloud2T = s2Cloud2ScrollW / s2StaticV
// 人物
const s2PeopleL = 860 / 2784
const s2PeopleScrollW = s2StaticW * (1 - s2PeopleL)
const s2PeopleD = s2StaticD + s2PeopleL * s2StaticT
const s2PeopleT = s2PeopleScrollW / s2StaticV
// 手
const s2HandW = wh * 0.046 * 158 / 113
const s2HandL = 810 / 2784
const s2HandScrollW = s2StaticW * (1 - s2HandL)
const s2HandD = s2StaticD + s2HandL * s2StaticT
const s2HandT = s2HandScrollW / s2StaticV
// 小孩
const s2ChildL = 1500 / 2784
const s2ChildScrollW = s2StaticW * (1 - s2ChildL)
const s2ChildD = s2StaticD + s2ChildL * s2StaticT
const s2ChildT = s2ChildScrollW / s2StaticV
// 小孩动画
const s2ChildL2 = 2000 / 2784
const s2ChildScrollW2 = s2StaticW * (1 - s2ChildL2)
const s2ChildD2 = s2StaticD + s2ChildL2 * s2StaticT
const s2ChildT2 = s2ChildScrollW2 / s2StaticV
// 飞机
const s2PlaneH = wh * 0.127
const s2PlaneW = s2PlaneH * 334 / 310
const s2PlaneD = s2ChildD2 + s2ChildT2 * 0.52
const s2PlaneT = s2ChildT2

// 场景右移完毕
const s2MoveEndD = s2StaticD + s2StaticT
// 场景下移
const s2EndD = s2PlaneD
const s2EndT = s2PlaneT
// 下移完成到结束
const s2RestD = s2EndD + s2EndT
// const s2RestT = config.scenesScrollT[0] + s2ScrollT - s2RestD

// 云朵
const s2CloudMoveD = s2MoveEndD
const s2CloudMoveT = config.scenesScrollT[0] + s2ScrollT - s2CloudMoveD

// 场景三门消失
const s3ScrollD = config.scenesScrollT[0] + config.scenesScrollT[1]
const s3ScrollT = config.scenesScrollT[2]
const s3BgFadeT = 0.1 * s3ScrollT

// 对话
const s2Talk1T = s2ScrollT * 0.03
const s2Talk1H = wh * 0.298
const s2Talk1W = s2Talk1H * 184 / 727
const s2Talk2T = s2ScrollT * 0.03
const s2Talk2H = wh * 0.376
const s2Talk2W = s2Talk2H * 199 / 915

const s2Talk2D = s2HandD + s2HandT * 0.4
const s2TextD = s2Talk2D + s2Talk2T * 6
const s2TextT = s2ScrollT * 0.12

const animations = {
  s2_cloud1: [
    {
      delay: s2CloudMoveD,
      duration: s2CloudMoveT,
      from: { x: ww - s2Cloud1ScrollW, y: 0 },
      to: { x: ww, y: -0.6 * wh }
    },
    {
      delay: s2Cloud1D,
      duration: s2Cloud1T,
      from: { x: ww },
      to: { x: ww - s2Cloud1ScrollW }
    }
  ],
  s2_cloud2: [
    {
      delay: s2CloudMoveD,
      duration: s2CloudMoveT,
      from: { x: ww - s2Cloud2ScrollW, y: 0.16 * wh },
      to: { x: -ww * 1.5, y: 0.3 * wh }
    },
    {
      delay: s2Cloud2D,
      duration: s2Cloud2T,
      from: { x: ww },
      to: { x: ww - s2Cloud2ScrollW }
    }
  ],
  s2_static: [
    {
      delay: s2StaticD,
      duration: s2StaticT,
      from: { x: ww },
      to: { x: ww - s2StaticW }
    },
    {
      delay: s2EndD,
      duration: s2EndT,
      from: { y: 0 },
      to: { y: wh }
    }
  ],
  s2_hand: [
    {
      duration: 1,
      to: { yoyo: true, repeat: -1, rotation: 0.1 }
    },
    {
      delay: s2HandD,
      duration: s2HandT,
      from: { x: ww + s2HandW },
      to: { x: ww + s2HandW - s2HandScrollW }
    },
    {
      delay: s2EndD,
      duration: s2EndT,
      from: { y: 0.768 * wh },
      to: { y: 1.768 * wh }
    }
  ],
  s2_people: [
    {
      delay: s2PeopleD,
      duration: s2PeopleT,
      from: { x: ww },
      to: { x: ww - s2PeopleScrollW }
    },
    {
      delay: s2EndD,
      duration: s2EndT,
      from: { y: 0.926 * wh },
      to: { y: 1.926 * wh }
    }
  ],
  s2_child: [
    {
      delay: s2ChildD,
      duration: s2ChildT,
      from: { x: ww },
      to: { x: ww - s2ChildScrollW }
    },
    {
      delay: s2ChildD2,
      duration: s2ChildT2,
      frames: getFrames('s2_child', 2, 1)
    },
    {
      delay: s2EndD,
      duration: s2EndT,
      from: { y: 0.836 * wh },
      to: { y: 1.836 * wh }
    }
  ],
  s2_plane: [
    {
      delay: s2PlaneD,
      duration: s2PlaneT,
      from: { width: s2PlaneW * 0.3, height: s2PlaneH * 0.3, y: 0.62 * wh },
      to: { width: s2PlaneW, height: s2PlaneH, y: 0.4 * wh }
    },
    {
      delay: s2PlaneD,
      duration: 0.02 * s2ScrollT,
      from: { alpha: 0 },
      to: { alpha: 1 }
    },
    {
      delay: s2RestD,
      duration: 0.05 * s2ScrollT,
      from: { width: s2PlaneW, height: s2PlaneH },
      to: { width: 0, height: 0 }
    }
  ],
  s2_door: [
    {
      delay: s2RestD + 0.08 * s2ScrollT,
      duration: 0.05 * s2ScrollT,
      from: { alpha: 0, height: 0 },
      to: { alpha: 1, height: 0.511 * wh }
    },
    {
      delay: s3ScrollD,
      duration: s3BgFadeT,
      from: { alpha: 1 },
      to: { alpha: 0 }
    }
  ],
  s2_cloud3: [
    {
      delay: s2CloudMoveD,
      duration: s2CloudMoveT,
      from: { x: ww, y: 0 },
      to: { x: 0, y: 1.84 * wh }
    }
  ],
  s2_text: [
    {
      delay: s2TextD,
      duration: s2TextT,
      from: { alpha: 0 },
      to: { alpha: 1, yoyo: true, repeat: 1, repeatDelay: s2TextT * 4 }
    }
  ],
  s2_talk1: [
    {
      delay: s2HandD + s2HandT * 0.2,
      duration: s2Talk1T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s2Talk1W, height: s2Talk1H, yoyo: true, repeat: 1, repeatDelay: s2Talk1T * 6, ease: 'ease' }
    },
    {
      delay: s2HandD * 0.99,
      duration: s2HandT,
      from: { x: ww + s2Talk1W },
      to: { x: ww + s2Talk1W - s2HandScrollW }
    }
  ],
  s2_talk2: [
    {
      delay: s2HandD + s2HandT * 0.4,
      duration: s2Talk2T,
      from: { alpha: 0, width: 0, height: 0 },
      to: { alpha: 1, width: s2Talk2W, height: s2Talk2H, yoyo: true, repeat: 1, repeatDelay: s2Talk2T * 6, ease: 'ease' }
    },
    {
      delay: s2HandD * 1.07,
      duration: s2HandT,
      from: { x: ww + s2Talk2W },
      to: { x: ww + s2Talk2W - s2HandScrollW }
    }
  ]
}

export default animations



// WEBPACK FOOTER //
// ./src/assets/scenes/s2/spritesAnimations.js